import { action, observable, observe } from "mobx";

const withSellerInquiryModal = BaseClass =>
  class extends BaseClass {
    @observable isSellerInquiryModalOpen = false;

    setInterestedSellerInquiryModalObservers() {
      observe(
        this,
        "isSellerInquiryModalOpen",
        ({ newValue: isSellerInquiryModalOpen }) => {
          if (isSellerInquiryModalOpen) {
            this.analyticsService.showModalGAEvent();
          }
        }
      );
    }

    @action.bound
    setIsSellerInquiryModalOpen(value) {
      this.isSellerInquiryModalOpen = value;
    }

    @action.bound
    openSellerInquiryModal() {
      this.setIsSellerInquiryModalOpen(true);
    }

    @action.bound
    closeSellerInquiryModal() {
      this.setIsSellerInquiryModalOpen(false);
    }
  };

export default withSellerInquiryModal;
